module.exports = __webpack_public_path__ + "fonts/subset-mplus-1p-light.woff2";